import React, { Component } from 'react';
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import { FormGroup, Input, Button, Container, FormFeedback } from 'reactstrap';
import { Link } from 'react-router-dom';
import c from '../../constants/Colors';
import { SvgAssets } from '../../assets/icons/iconSvg';
import { login, cambiarContrasenia } from '../../store/sagas/authApi';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";
import { notificacion } from '../../utilitarios/util';

function CurrentPassword({ dadComponent }) {
  const { showError, isMobile, currentPwd, viewPassword1, viewPassword2, showErrorConfirmar, showErrorConfirmarCurrent, errorValidacion, errorValidacionConfirmarCurrent, password, password1, password2 } = dadComponent.state;

  return (
    <div>
      <div className="card card_container">
        <h4 className="title-2 azul mobile"><SvgAssets icon="icon-lock-eye" className='icon-block' fill={c.azulClaro} />Contraseña<br /> actual</h4>
        <h4 className="title-2 azul desktop"><SvgAssets icon="icon-lock-eye" className="mr-2" fill={c.azulClaro} />Actualizar contraseña</h4>
        <form>
          <FormGroup className="icon">
            <Input className="azul" type={currentPwd ? 'text' : 'password'} name="password" placeholder="Confirmar contraseña"
              onKeyPress={(e) => { if (e.which == 13 || e.which == 10) e.preventDefault(); }}
              onKeyUp={(e) => { if (e.keyCode == 13 || e.keyCode == 10) { e.preventDefault(); isMobile ? password == '' ? (() => { })() : dadComponent.validarContrasenia(isMobile) : password == '' || password1 == '' || password2 == '' ? (() => { })() : dadComponent.validarContrasenia(isMobile); } }}
              onChange={(password) => dadComponent.setPassword(password)}
            />
            <Button color="link" className="btn-icon" onClick={dadComponent.toggleCurrentPassword}>
              <SvgAssets icon={currentPwd ? 'icon-eye' : 'icon-eye-close'} fill={c.azulClaro} />
            </Button>
            {showErrorConfirmarCurrent ? <FormFeedback>{errorValidacionConfirmarCurrent}</FormFeedback> : null}
          </FormGroup>
        </form>
        <hr className="desktop mb-4 mx-auto" style={{ borderColor: '#E2E2E2', maxWidth: 358 }} />
        {!isMobile ? <form>
          <FormGroup className="icon">
            <Input className="naranja" type={viewPassword1 ? 'text' : 'password'} name="password" placeholder="Contraseña"
              onKeyPress={(e) => { if (e.which == 13 || e.which == 10) e.preventDefault(); }}
              onKeyUp={(e) => { if (e.keyCode == 13 || e.keyCode == 10) { e.preventDefault(); password == '' || password1 == '' || password2 == '' ? (() => { })() : dadComponent.validarContrasenia(isMobile); } }}
              onChange={(password) => dadComponent.setPassword1(password)}
            />
            <Button color="link" className="btn-icon naranja" onClick={dadComponent.togglePassword1}>
              <SvgAssets icon={viewPassword1 ? 'icon-eye' : 'icon-eye-close'} fill={c.naranja} />
            </Button>
            {(showError) ? <FormFeedback>{errorValidacion}</FormFeedback> : null}
          </FormGroup>
          <FormGroup className="icon">
            <Input className="naranja" type={viewPassword2 ? 'text' : 'password'} name="password" placeholder="Confirmar contraseña"
              onKeyPress={(e) => { if (e.which == 13 || e.which == 10) e.preventDefault(); }}
              onKeyUp={(e) => { if (e.keyCode == 13 || e.keyCode == 10) { e.preventDefault(); password == '' || password1 == '' || password2 == '' ? (() => { })() : dadComponent.validarContrasenia(isMobile); } }}
              onChange={(password) => dadComponent.setPassword2(password)}
            />
            <Button color="link" className="btn-icon naranja" onClick={dadComponent.togglePassword2}>
              <SvgAssets icon={viewPassword2 ? 'icon-eye' : 'icon-eye-close'} fill={c.naranja} />
            </Button>
            {(showErrorConfirmar) ? <FormFeedback>Las contraseñas no coinciden</FormFeedback> : null}
          </FormGroup>
          <p className="paragraph-2 desktop_parrafo3" style={{ color: c.naranja }}>Debe contener al menos una letra mayúscula, una minúscula, un número y un símbolo. Mínimo 6 y máximo 20 caracteres.</p>
        </form> : null}
        <div className="text-center mt-5 mobile">
          <button className='btn-block red'
            disabled={isMobile ? password == '' || showErrorConfirmarCurrent : password == '' || password1 == '' || password2 == '' || showErrorConfirmarCurrent || showError || showErrorConfirmar}
            onClick={() => dadComponent.validarContrasenia(isMobile)}>
            {/* onClick={() => isMobile ? dadComponent.validarContrasenia : dadComponent.updateContrasenia}> */}
            {isMobile ? "siguiente" : "actualizar"}<SvgAssets icon="icon-arrow-right" className='svg-right' fill="#fff" />
          </button>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button className='btn-block red'
          disabled={isMobile ? password == '' || showErrorConfirmarCurrent : password == '' || password1 == '' || password2 == '' || showErrorConfirmarCurrent || showError || showErrorConfirmar}
          onClick={() => dadComponent.validarContrasenia(isMobile)}>
          {/* onClick={() => isMobile ? dadComponent.validarContrasenia : dadComponent.updateContrasenia}> */}
          {isMobile ? "siguiente" : "actualizar"}<SvgAssets icon="icon-arrow-right" className='svg-right' fill="#fff" />
        </button>
      </div>
    </div>
  )
}

function NuevaContraseña({ dadComponent }) {
  const { password1, password2, viewPassword1, viewPassword2, showError, showErrorConfirmar, errorValidacion, loading } = dadComponent.state;
  return (
    <div>
      <div className="card card_container">
        <h4 className="text-center title-2 naranja">
          <SvgAssets icon="icon-lock" className='icon-block' fill={c.naranja} />
          Nueva<br className="mobile" /> contraseña
        </h4>
        <form>
          <FormGroup className="icon">
            <Input className="naranja" type={viewPassword1 ? 'text' : 'password'} name="password" placeholder="Contraseña"
              onChange={(password) => dadComponent.setPassword1(password)}
            />
            <Button color="link" className="btn-icon naranja" onClick={dadComponent.togglePassword1}>
              <SvgAssets icon={viewPassword1 ? 'icon-eye' : 'icon-eye-close'} fill={c.naranja} />
            </Button>
            {(showError) ? <FormFeedback>{errorValidacion}</FormFeedback> : null}
          </FormGroup>
          <FormGroup className="icon">
            <Input className="naranja" type={viewPassword2 ? 'text' : 'password'} name="password" placeholder="Confirmar contraseña"
              onChange={(password) => dadComponent.setPassword2(password)}
            />
            <Button color="link" className="btn-icon naranja" onClick={dadComponent.togglePassword2}>
              <SvgAssets icon={viewPassword2 ? 'icon-eye' : 'icon-eye-close'} fill={c.naranja} />
            </Button>
            {(showErrorConfirmar) ? <FormFeedback>Las contraseñas no coinciden</FormFeedback> : null}
          </FormGroup>
          <p className="paragraph-2 desktop_parrafo3" style={{ color: c.naranja }}>Debe contener al menos una letra mayúscula, una minúscula, un número y un símbolo. Mínimo 6 y máximo 20 caracteres.</p>
        </form>
        <div className="text-center mt-5">
          <button className='btn-block red'
            onClick={() => dadComponent.updateContrasenia()}
          // onClick={dadComponent.nextStep}
          >
            Actualizar<SvgAssets icon="icon-arrow-right" className='svg-right' fill="#fff" />
          </button>
        </div>
      </div>
    </div>
  )
}

function Message({ dadComponent }) {
  const { } = dadComponent.state;
  return (
    <div>
      <div className="card card_container">
        <h4 className="title-2 mobile" style={{ color: c.verdeClaro }}><SvgAssets icon="icon-eye" className='icon-block' fill={c.verdeClaro} />Contraseña<br className="mobile" /> actualizada</h4>
        <h4 className="title-2 desktop" style={{ color: c.verdeClaro }}><SvgAssets icon="icon-eye" className='mr-2' fill={c.verdeClaro} />Contraseña actualizada</h4>
        <p className="paragraph-1 text-center mb-text light mx-auto" style={{ maxWidth: 438, color: c.verdeClaro }}>
          Tu nueva contraseña ha sido actualizada, <strong>sigue disfrutando de la experiencia Asiri.</strong>
        </p>
        <div className="text-center mt-5 mobile">
          <Link to="/perfil" style={{ textDecoration: 'none' }}>
            <button className='btn-block red'>Entendido</button>
          </Link>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <Link to="/perfil" style={{ textDecoration: 'none' }}>
          <button className='btn-block red'>Entendido</button>
        </Link>
      </div>
    </div>
  )
}

export class CambiarContrasenia extends Component {
  static displayName = CambiarContrasenia.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      isMobile: isMobile,
      step: 0,
      currentPwd: false,
      correoElectronico: null,
      email: null,
      dispositivoDealer: null,
      codigoDealer: null,
      viewPassword1: false,
      viewPassword2: false,
      password1: false,
      password2: false,
      errorValidacionConfirmarCurrent: null,
      errorValidacion: null,
      showError: false,
      showErrorConfirmar: false,
      showErrorConfirmarCurrent: false,
      loading: true
    };
    // this.nextStep = this.nextStep.bind(this);
    this.backStep = this.backStep.bind(this);
    this.toggleCurrentPassword = this.toggleCurrentPassword.bind(this);
    this.togglePassword1 = this.togglePassword1.bind(this);
    this.togglePassword2 = this.togglePassword2.bind(this);
  }

  nextStep(step = null) {
    this.setState({ step: step == null ? this.state.step + 1 : step })
  }

  backStep() {
    console.log("this.state.step===>", this.state.step);
    if (this.state.step == 0) { 
        this.props.history.push({
          pathname: '/perfil', 
          state: {  }
        }); 
    } else
      this.setState({ step: this.state.step - 1 })
  }
  toggleCurrentPassword() {
    this.setState({ currentPwd: !this.state.currentPwd })
  }
  togglePassword1() {
    this.setState({ viewPassword1: !this.state.viewPassword1 })
  }
  togglePassword2() {
    this.setState({ viewPassword2: !this.state.viewPassword2 })
  }

  setPassword1 = (e) => {
    let value = e.currentTarget.value;
    var re = new RegExp(/(?=.*[A-Z]){1}/);
    this.setState({ showError: !re.test(value), password1: value, errorValidacion: !re.test(value) ? "Debe ingresar al menos una letra Mayúscula" : null });
    // (re.test(value)) ? 
    // this.setState({ showError:false,password1: value}) : 
    // this.setState({ showError:true,password1: value});
  }
  setPassword2 = (e) => {
    let value = e.currentTarget.value;
    this.setState({ showErrorConfirmar: this.state.password1 != value, password2: value });
    // (this.state.password1!=value) ? 
    // this.setState({ showErrorConfirmar:true,password2: value }) : 
    // this.setState({ showErrorConfirmar:false,password2: value });
  }

  validarContrasenias = () => {
    this.setState({ loading: true });
    let valido = true;
    var re = new RegExp(/(?=.*[A-Z]){1}/);
    if ((this.state.password1 == '' || this.state.password1 == null) || (re.test(this.state.password1)) == false) {
      valido = false;
      this.setState({ showError: true, loading: false });
    }
    if ((this.state.password2 == '' || this.state.password2 == null) || (this.state.password1 != this.state.password2)) {
      valido = false;
      this.setState({ showErrorConfirmar: true, loading: false });
    }
    return valido;
  }

  updateContrasenia = async (step = null) => {
    this.setState({ showErrorConfirmar: false, showError: false, loading: true });

    if (this.validarContrasenias()) {
      let CorreoElectronico = this.state.email;
      let Contrasenia = this.state.password1;
      let DispositivoDealer = this.state.dispositivoDealer;
      let CodigoDealer = this.state.codigoDealer;

      cambiarContrasenia(CorreoElectronico, Contrasenia, DispositivoDealer, CodigoDealer)
        .then(result => {
          if (result.mo.type == "success") {
            this.setState({ loading: false });
            this.nextStep(step);
          } else {
            this.setState({ loading: false, showError: true, errorValidacion: result.mo.listMessage.join(", ") });

            // throw new Error(result.mo.listMessage.join(", "));
          }
        }).catch((error) => {
          this.setState({ loading: false });
          console.log("updateContrasenia ", error);
        });
    }
  }

  checkParams() {
    const { state } = this.props.location;
    this.setState({ correoElectronico: state.correoElectronico, loading: false });
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }
  setPassword = (e) => {
    let value = e.currentTarget.value;
    this.setState({ password: value, showErrorConfirmarCurrent: (value == '' || value == null), loading: false, errorValidacionConfirmarCurrent: (value == '' || value == null) ? 'Debe ingresar la contraseña actual' : '' });
  }

  validarContrasenia(isMobile) {
    let Contrasenia = this.state.password;
    let CorreoElectronico = this.state.correoElectronico;
    this.setState({ loading: true, showErrorConfirmarCurrent: false, errorValidacionConfirmarCurrent: '' });
    login({ CorreoElectronico, Contrasenia })
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ email: result.dto.correoElectronico, dispositivoDealer: result.dto.codigoDispositivo, codigoDealer: result.dto.codcliente }, isMobile ? this.nextStep : () => this.updateContrasenia(2))
          // this.nextStep();
          // this.props.navigation.navigate('PerfilNuevaContrasenia', { email: result.dto.correoElectronico, 
          //   dispositivoDealer: result.dto.codigoDispositivo, codigoDealer: result.dto.codcliente });
          this.setState({ loading: false });
        } else {
          this.setState({ showErrorConfirmarCurrent: true, errorValidacionConfirmarCurrent: 'La contraseña ingresada es incorrecta', loading: false });
        }
      }).catch((error) => {
        this.setState({ loading: false });
        error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
        notificacion("Perfil", error.message ?? null);
      });
  }

  renderStep() {
    switch (this.state.step) {
      case 0:
        return <CurrentPassword dadComponent={this} />
      case 1:
        return <NuevaContraseña dadComponent={this} />
      case 2:
        return <Message dadComponent={this} />
      default:
        return <Message dadComponent={this} />
    }
  }

  render() {
    const { loading, step } = this.state;
    const auth = this.context;
    console.log('step', step === 1)
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="rs_container desktop">
          <button className='btn-icon back mobile'>
            <SvgAssets icon="icon-arrow-left" fill={c.azulClaro} />
          </button>
          <SvgAssets className="icon" icon="icon-user" fill={c.rojoClaro} />
          <h6 className="title-2">{auth.userRazonSocial}</h6>
          <p className="paragraph-1 azul">Repuestos</p>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/perfil'>Mi Perfil</Link></li>
              <li>Cambiar Contraseña</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <Spinner visible={loading} />
          {/* <Button color="link" className="btn-back mobile" onClick={this.backStep}><SvgAssets icon="icon-arrow-left" fill="#fff" /></Button> */}
          {step != 1 ?
            <Button color="link" className="btn-back mobile" onClick={this.backStep}>
              <SvgAssets icon="icon-arrow-left" fill={'#fff'} />
            </Button> : null}
          {this.renderStep()}
        </Container>
      </div>
    );
  }
}
